import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';

import Footer from './components/Footer';

import './index.css';
import WhatsAppButton from './components/WhatsAppButton'
import { useEffect } from 'react';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function AppContent() {
  const location = useLocation();

  // Hide header/footer only for exact dashboard layout routes
  const hideHeaderFooter = location.pathname.startsWith('/dashboard');

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
        {!hideHeaderFooter && <Header />}
        <AppRoutes />
      </main>
      {!hideHeaderFooter && <Footer />}
      {!hideHeaderFooter && <WhatsAppButton />}
    </div>
  );
}

function App() {
  return (

      <Router>
        <AppContent />
      </Router>

  );
}

export default App;
